const observePerformance = () => {
  return performance.getEntriesByType('navigation');
};

export default observePerformance;
